<div class="container-fluid">
  <div [hidden]="!loading" class="loadingContainer">
    <mat-spinner
      class="loading-spinner"
      strokeWidth="6"
      color="accent"
      diameter="75"></mat-spinner>
  </div>
  <div #embedContainer class="embedContainer mb-3" [hidden]="loading"></div>
</div>
